import React, { ComponentPropsWithoutRef } from 'react';
import { Box } from '@givebutter/primitives/box';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';

const EngageFeature = ({ className, children, ...props }: ComponentPropsWithoutRef<'div'>) => {
    return (
        <Box className={twMerge('flex min-h-[12rem] flex-col p-5', className)} {...props}>
            {children}
        </Box>
    );
};
const EngageFeatureHeader = ({ className, ...props }: React.HTMLProps<HTMLParagraphElement>) => {
    return <div className={twMerge('flex', className)} {...props} />;
};

const EngageFeatureTitle = ({ className, ...props }: React.HTMLProps<HTMLParagraphElement>) => {
    return <p className={twMerge('my-2 font-medium text-neutral-800', className)} {...props} />;
};

const EngageFeatureIcon = (props: FontAwesomeIconProps) => {
    return (
        <div className="mr-4 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-green-400 [&>svg]:text-white">
            <FontAwesomeIcon {...props} />
        </div>
    );
};

const EngageFeatureDescription = ({
    className,
    ...props
}: React.HTMLProps<HTMLParagraphElement>) => {
    return <p className={twMerge('mb-3 ml-14 leading-5', className)} {...props} />;
};

const Root = EngageFeature;
const Header = EngageFeatureHeader;
const Title = EngageFeatureTitle;
const Icon = EngageFeatureIcon;
const Description = EngageFeatureDescription;

export {
    Root,
    Header,
    Title,
    Icon,
    Description,
    //
    EngageFeature,
    EngageFeatureHeader,
    EngageFeatureTitle,
    EngageFeatureIcon,
    EngageFeatureDescription,
};
